// Guarded localStorage access (audit P2).
//
// Touching `localStorage` can THROW synchronously — Safari private browsing
// (quota 0 on write), "block all cookies" settings (SecurityError on any
// access), sandboxed iframes. App.tsx used to read `mafia.lang` bare at
// module render, which white-screened the whole app in those modes. Every
// storage touch in the client goes through these helpers (ws.ts and
// usePerfLite.ts had their own ad-hoc guards before; unified here) and
// degrades to in-memory defaults instead of crashing.

export function storageGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function storageSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Private browsing / blocked storage — preference simply won't persist.
  }
}

export function storageRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Same — nothing to remove if we never could write.
  }
}
